<template>
  <v-footer app dark fixed color="primary" id="ciaobooking-footer" class="d-print-none">
    <v-btn
      v-if="$can('INTERNAL_SUPPORT') && !$isMobile()"
      color="admin"
      icon
      @click="isOpenUserSupportRequest = true"
      small
    >
      <v-icon>mdi-phone-plus</v-icon>
    </v-btn>
    <span class="caption">
      CiaoBooking Srl {{ $moment().format('YYYY') }} All Rights Reserved
      <a href="https://www.facebook.com/ciaobooking" class="ml-2" target="_blank">
        <v-icon small>mdi-facebook</v-icon>
      </a>
      <a href="https://www.capterra.it/software/206171/ciaobooking" class="ml-2" target="_blank">
        <v-icon small>mdi-message-draw</v-icon>
      </a>
    </span>
    <v-spacer></v-spacer>
    <v-btn v-if="isEmergencyVisible" small color="error" @click="openEmergencyContact()">
      <v-icon>mdi-lifebuoy</v-icon> {{ $lang('main.emergency.cta') }}
    </v-btn>
    <v-btn small text @click="openNote" class="mr-1">
      <v-icon :color="!!notes ? 'warning' : ''">mdi-note-plus</v-icon>
    </v-btn>
    <span v-if="!$isMobile()">
      {{ clock }}<v-icon small class="ml-2">mdi-clock</v-icon>
      v.{{ appVersion }}
    </span>
    <v-dialog v-model="isNoteOpen">
      <v-card v-if="isNoteOpen" color="#ffc" flat tile>
        <v-card-title>{{ $lang('main.footer.notes.title') }}</v-card-title>
        <v-card-text>
          <v-textarea
            class="post-it"
            rows="10"
            v-model="notes"
            prepend-icon="mdi-note"
            :hint="$lang('main.footer.notes.hint')"
            persistent-hint
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="saveNote" color="primary">
            {{ $lang('main.crud.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isEmergencyOpen" width="400">
      <v-card v-if="isEmergencyOpen">
        <v-card-title class="error white--text mb-2">
          {{ $lang('main.emergency.title') }}
        </v-card-title>
        <v-card-text>
          <p>
            {{ $lang('main.emergency.description') }}
          </p>
          <p>
            {{ $lang('main.emergency.cost') }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-btn :to="{ name: 'tickets'}" @click="isEmergencyOpen = false">
            <v-icon class="mr-2" color="primary">mdi-ticket-account</v-icon>
            {{ $lang('main.titles.tickets') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn v-show="!isShowEmergencyPhone" color="success" @click="isShowEmergencyPhone = true">
            <v-icon>mdi-phone</v-icon>
            {{ $lang('main.emergency.call') }}
          </v-btn>
          <v-btn v-show="isShowEmergencyPhone" :href="`tel://${$lang('main.emergency.phone')}`" color="success">
            <v-icon>mdi-phone</v-icon>
            {{ $lang('main.emergency.phone') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isOpenUserSupportRequest" width="50vw" scrollable>
      <user-support-request-creation
        v-if="isOpenUserSupportRequest"
        @cancel="isOpenUserSupportRequest = false"
        @success="isOpenUserSupportRequest = false"
      />
    </v-dialog>
  </v-footer>
</template>

<script>
import {
  LOAD_NOTES,
  SAVE_NOTES
} from '@/store/app/actions';

import UserSupportRequestCreation from '@/pages/user-support-requests/CreationForm';

import MixpanelEvents from "@/constants/events";

export default {
  name: "CiaoBookingFooter",
  components: {
    UserSupportRequestCreation
  },
  data() {
		return {
			drawerModel: true,
      minimized: false,
      clock: null,
      isNoteOpen: false,
      isEmergencyOpen: false,
      notes: null,
      isShowEmergencyPhone: false,
      isOpenUserSupportRequest: false,
      appVersion: APP_VERSION,
		};
  },
  mounted() {
    this.clock = this.$moment().format('DD/MM/YYYY HH:mm');

    setInterval(() => {
        this.clock = this.$moment().format('DD/MM/YYYY HH:mm');
    }, 60000);

    this.$store.dispatch(LOAD_NOTES).then(response => {
      this.notes = response;
    });
  },
  methods: {
    openNote() {
      this.isNoteOpen = true;
      this.$monitorService.track(MixpanelEvents.RECEPTION_NOTES_OPENED);
    },
    saveNote() {
      this.$store.dispatch(SAVE_NOTES, this.notes);
      this.isNoteOpen = false;
      this.$monitorService.track(MixpanelEvents.RECEPTION_NOTES_SAVED);
    },
    openEmergencyContact() {
      this.isEmergencyOpen = true;
      this.$monitorService.track(MixpanelEvents.EMERGENCY_CONTACT_OPEN);
    },
  },
  computed: {
    isEmergencyVisible() {
      return false;
      const eveningStartTime = this.$moment().tz('Europe/Rome').set({"hour": 18, "minute": 0});
      const eveningEndTime = this.$moment().tz('Europe/Rome').add(1, 'day').set({"hour": 21, "minute": 0});

      const weekDay = this.$moment().day();
      const isEveningOutOfOffice = this.$moment().isBetween(eveningStartTime, eveningEndTime);

      return weekDay === 6 || weekDay === 0 || isEveningOutOfOffice;
    },
  }
};
</script>